(() => {
  const quantities = [
    { qty: 1, label: "1 BAG (1 LB)" },
    { qty: 2, label: "2 BAGS (2 LB)" },
    { qty: 3, label: "3 BAGS (3 LB)", popular: true },
    { qty: 4, label: "4 BAGS (4 LB)" },
    { qty: 5, label: "5 BAGS (5 LB)", best: true },
    { qty: 6, label: "6 BAGS (6 LB)" }
  ];

  const FREE_SHIP = 24.99;
  const money = (n) => "$" + n.toFixed(2);

  // Default: 3 bags. Pricing always comes from the live Shopify variant.
  const state = { qty: 3, purchase: "once", cartCount: 0, busy: false };

  const qtyGrid = document.getElementById("qty-grid");
  const liveTotal = document.getElementById("live-total");
  const totalLabel = document.getElementById("total-label");
  const summaryPrice = document.getElementById("summary-price");
  const toast = document.getElementById("toast");
  const shipProgress = document.getElementById("ship-progress");
  const stickyAtc = document.getElementById("sticky-atc");
  const stickyPrice = document.getElementById("sticky-price");
  const stickyDetail = document.getElementById("sticky-detail");
  const cartBadge = document.getElementById("cart-badge");
  const hero = document.getElementById("hero");
  const purchase = document.getElementById("purchase");
  const productForm = document.getElementById("fc-product-form");
  const variantInput = document.getElementById("fc-variant-id");
  const quantityInput = document.getElementById("fc-quantity");
  const sellingPlanInput = document.getElementById("fc-selling-plan");
  const purchaseToggle = document.getElementById("purchase-toggle");
  const frequencySelect = document.getElementById("fc-frequency");
  const frequencyWrap = document.getElementById("freq-wrap");
  const unitPrice = variantInput && variantInput.dataset.unitPriceCents
    ? Number(variantInput.dataset.unitPriceCents) / 100
    : 0;

  function selected() {
    return quantities.find((q) => q.qty === state.qty) || quantities[0];
  }

  function currentPrice() {
    const perBag = state.purchase === "subscribe" && frequencySelect
      ? Number(frequencySelect.selectedOptions[0].dataset.priceCents || 0) / 100
      : unitPrice;
    return +(perBag * state.qty).toFixed(2);
  }

  function showToast(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add("show");
    clearTimeout(toast._t);
    toast._t = setTimeout(() => toast.classList.remove("show"), 3400);
  }

  function syncQuantityInput() {
    if (quantityInput) quantityInput.value = String(state.qty);
  }

  function renderQty() {
    if (!qtyGrid) return;
    qtyGrid.innerHTML = quantities.map((item) => {
      const selectedClass = item.qty === state.qty ? " selected" : "";
      let badge = "";
      if (item.popular) badge = '<span class="tag tag-popular">MOST POPULAR</span>';
      else if (item.best) badge = '<span class="tag tag-value">BEST VALUE</span>';
      const total = +(unitPrice * item.qty).toFixed(2);
      const ship = total >= FREE_SHIP ? '<div class="tag-ship">✓ FREE SHIPPING</div>' : "";
      return (
        '<button type="button" class="qty-option' + selectedClass + '" data-qty="' + item.qty + '" role="radio" aria-checked="' + (item.qty === state.qty) + '">' +
          badge +
          '<span class="qty-label">' + item.label + '</span>' +
          '<span class="qty-price">' + money(total) + '</span>' +
          '<span class="qty-per">' + money(unitPrice) + '/LB</span>' +
          ship +
        '</button>'
      );
    }).join("");

    qtyGrid.querySelectorAll(".qty-option").forEach((btn) => {
      btn.addEventListener("click", () => {
        state.qty = Number(btn.dataset.qty);
        syncQuantityInput();
        renderQty();
        updateTotals();
      });
    });
  }

  function updateShipProgress() {
    if (!shipProgress) return;
    const item = selected();
    const listPrice = currentPrice();
    if (listPrice >= FREE_SHIP) {
      shipProgress.className = "ship-progress show";
      shipProgress.innerHTML =
        '✓ You’ve unlocked <strong>free shipping</strong>' +
        '<div class="bar" aria-hidden="true"><span style="width:100%"></span></div>';
      return;
    }
    const need = Math.max(0, FREE_SHIP - listPrice);
    const bagsNeeded = unitPrice > 0 ? Math.ceil(need / unitPrice) : 0;
    const pct = Math.min(100, Math.round((listPrice / FREE_SHIP) * 100));
    shipProgress.className = "ship-progress show warn";
    shipProgress.innerHTML =
      'Add <strong>' + bagsNeeded + ' more bag' + (bagsNeeded > 1 ? 's' : '') +
      '</strong> for free shipping (need ' + money(need) + ' more toward $24.99)' +
      '<div class="bar" aria-hidden="true"><span style="width:' + pct + '%"></span></div>';
  }

  function updateSticky() {
    if (!stickyPrice || !stickyDetail) return;
    const item = selected();
    const price = currentPrice();
    stickyPrice.textContent = money(price);
    stickyDetail.textContent = item.qty + " bag" + (item.qty > 1 ? "s" : "") +
      (state.purchase === "subscribe" ? " · Subscription" : " · One-time purchase");
  }

  function updateTotals() {
    const item = selected();
    const price = currentPrice();
    if (liveTotal) liveTotal.textContent = money(price);
    if (summaryPrice) summaryPrice.textContent = money(price);
    if (totalLabel) totalLabel.textContent = state.purchase === "subscribe" ? "Subscription total" : "Order total";
    syncQuantityInput();
    updateShipProgress();
    updateSticky();
  }

  async function updateCartBadgeFromShopify() {
    try {
      const res = await fetch("/cart.js", { credentials: "same-origin" });
      if (!res.ok) return;
      const cart = await res.json();
      if (cartBadge && typeof cart.item_count === "number") {
        cartBadge.textContent = String(cart.item_count);
        state.cartCount = cart.item_count;
      }
    } catch (_) { /* preview / offline */ }
  }

  async function addToCartShopify() {
    const variantId = variantInput && variantInput.value;
    if (!variantId) {
      showToast("Product variant unavailable — check product handle in theme.");
      return false;
    }

    syncQuantityInput();
    const payload = {
      id: Number(variantId),
      quantity: state.qty
    };
    if (state.purchase === "subscribe" && sellingPlanInput && sellingPlanInput.value) {
      payload.selling_plan = Number(sellingPlanInput.value);
    }

    const res = await fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify(payload)
    });

    if (!res.ok) {
      let msg = "Could not add to cart (" + res.status + ")";
      try {
        const err = await res.json();
        if (err && err.description) msg = err.description;
        else if (err && err.message) msg = err.message;
      } catch (_) {}
      throw new Error(msg);
    }

    await updateCartBadgeFromShopify();
    window.location.href = "/cart";
    return true;
  }

  function addToCartPreview() {
    const item = selected();
    const price = currentPrice();
    state.cartCount += item.qty;
    if (cartBadge) cartBadge.textContent = String(state.cartCount);
    showToast(
      "Added " + item.qty + " bag" + (item.qty > 1 ? "s" : "") +
      " — " + money(price) + (state.purchase === "subscribe" ? " (subscription)" : " (one-time purchase)")
    );
  }

  async function addToCart() {
    if (state.busy) return;
    state.busy = true;
    const btns = [
      document.getElementById("add-to-cart"),
      document.getElementById("sticky-atc-btn")
    ].filter(Boolean);
    btns.forEach((b) => { b.disabled = true; });

    try {
      const onShopify = !!(productForm && variantInput && variantInput.value);
      if (onShopify) {
        await addToCartShopify();
      } else {
        addToCartPreview();
      }
    } catch (err) {
      showToast(err && err.message ? err.message : "Add to cart failed");
    } finally {
      state.busy = false;
      btns.forEach((b) => { b.disabled = false; });
    }
  }

  const atcBtn = document.getElementById("add-to-cart");
  const stickyBtn = document.getElementById("sticky-atc-btn");
  if (atcBtn) atcBtn.addEventListener("click", addToCart);
  if (stickyBtn) stickyBtn.addEventListener("click", addToCart);

  function setPurchase(type) {
    if (type === "subscribe" && !frequencySelect) return;
    state.purchase = type;
    if (purchaseToggle) {
      purchaseToggle.querySelectorAll("[data-purchase]").forEach((btn) => {
        const active = btn.dataset.purchase === type;
        btn.classList.toggle("selected", active);
        btn.setAttribute("aria-checked", String(active));
      });
    }
    if (frequencyWrap) frequencyWrap.classList.toggle("show", type === "subscribe");
    if (sellingPlanInput) {
      sellingPlanInput.value = type === "subscribe" && frequencySelect ? frequencySelect.value : "";
    }
    updateTotals();
  }

  if (purchaseToggle) {
    purchaseToggle.querySelectorAll("[data-purchase]").forEach((btn) => {
      btn.addEventListener("click", () => setPurchase(btn.dataset.purchase));
    });
  }
  if (frequencySelect) {
    frequencySelect.addEventListener("change", () => {
      if (sellingPlanInput && state.purchase === "subscribe") sellingPlanInput.value = frequencySelect.value;
      updateTotals();
    });
  }

  document.querySelectorAll(".acc-item").forEach((item) => {
    const btn = item.querySelector(".acc-btn");
    if (!btn) return;
    btn.addEventListener("click", () => {
      const open = item.classList.contains("open");
      document.querySelectorAll(".acc-item").forEach((el) => {
        el.classList.remove("open");
        const b = el.querySelector(".acc-btn");
        if (b) b.setAttribute("aria-expanded", "false");
      });
      if (!open) {
        item.classList.add("open");
        btn.setAttribute("aria-expanded", "true");
      }
    });
  });

  function syncSticky() {
    if (!hero || !stickyAtc) return;
    const heroBottom = hero.getBoundingClientRect().bottom;
    const purchaseRect = purchase ? purchase.getBoundingClientRect() : null;
    const purchaseVisible = purchaseRect &&
      purchaseRect.top < window.innerHeight * 0.7 &&
      purchaseRect.bottom > 80;
    const pastHero = heroBottom < 40;
    const show = pastHero && !purchaseVisible && window.innerWidth < 900;
    stickyAtc.hidden = false;
    stickyAtc.classList.toggle("visible", show);
    document.body.classList.toggle("has-sticky", show);
  }

  window.addEventListener("scroll", syncSticky, { passive: true });
  window.addEventListener("resize", syncSticky);
  syncSticky();

  if (productForm && variantInput && variantInput.value) {
    updateCartBadgeFromShopify();
  }

  renderQty();
  updateTotals();
})();
